type TruncatedAxisTickProps = {
  x?: number;
  y?: number;
  payload?: { value?: string | number };
  maxLength: number;
  fontSize?: number;
  fill?: string;
};

export const truncateLabel = (label: string, maxLength: number): string =>
  label.length > maxLength ? `${label.slice(0, maxLength)}...` : label;

export const TruncatedAxisTick = ({
  x,
  y,
  payload,
  maxLength,
  fontSize,
  fill = "#374151",
}: TruncatedAxisTickProps) => {
  const label = String(payload?.value ?? "");
  return (
    <text x={x} y={y} dy={4} textAnchor="end" fontSize={fontSize} fill={fill}>
      <title>{label}</title>
      {truncateLabel(label, maxLength)}
    </text>
  );
};
